import { useRef, useEffect } from 'react'

export const useAutorefresh = (refresh: () => any, refreshRate: number) => {
  const refreshFnRef = useRef(refresh)
  refreshFnRef.current = refresh

  const autorefreshRef = useRef<ReturnType<typeof setInterval>>()
  useEffect(() => {
    const clear = () => {
      if (autorefreshRef.current) {
        clearInterval(autorefreshRef.current)
        autorefreshRef.current = undefined
      }
    }

    clear()
    if (refreshRate > 0) {
      refreshFnRef.current()
      autorefreshRef.current = setInterval(() => {
        refreshFnRef.current()
      }, refreshRate)
    }

    return clear
  }, [refreshRate])
}
